/**
 * Validation for LFA excluded email domain (mirrors backend).
 * - Domain only: no protocol or path (no http://, https://, or ://).
 * - Characters: only a–z, 0–9, dots (.), hyphens (-).
 * - Shape: must start and end with letter or digit; only letters, digits, dots, hyphens in between.
 * - At least one dot (reject single labels like "localhost").
 */
import normalizeExcludedEmailDomain from '~/components/page/Settings/LFASettings/utils/normalizeExcludedEmailDomain';

const DOMAIN_REGEX = /^[a-z0-9]([a-z0-9.-]*[a-z0-9])?$/;

export type ExcludedEmailDomainErrorKey =
  | 'empty'
  | 'noProtocol'
  | 'mustHaveDot'
  | 'invalidChars';

const validateExcludedEmailDomain = (
  value: string,
): {
  valid: boolean;
  normalized: string;
  error?: ExcludedEmailDomainErrorKey;
} => {
  const normalized = normalizeExcludedEmailDomain(value);
  if (normalized === '') {
    return { valid: false, normalized: '', error: 'empty' };
  }
  if (normalized.includes('://')) {
    return { valid: false, normalized, error: 'noProtocol' };
  }
  if (!normalized.includes('.')) {
    return { valid: false, normalized, error: 'mustHaveDot' };
  }
  if (!DOMAIN_REGEX.test(normalized)) {
    return { valid: false, normalized, error: 'invalidChars' };
  }
  return { valid: true, normalized };
};

export default validateExcludedEmailDomain;
